exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".field-container--social_series_detail .field-label[data-v-b4ffe21e]{margin-bottom:14px}", ""]);

// exports
